import { Action } from 'redux';
import { Map } from 'immutable';

import {
    SEARCH_REQUEST,
    SEARCH_RESPONSE,
    SEARCH_ERROR,
    RESET_SEARCH,
    SET_HOTEL,
    SET_REGION,
    SEARCH_QUERY,
    SEARCH_RESIDENCIES_RESPONSE,
    SEARCH_RESIDENCY_QUERY,
    RESET_RESIDENCY_SEARCH,
    SET_RESIDENCY
} from '../../actions/Hotels/search';

import { SearchHotel } from '../../models/Hotels/SearchHotel';
import { SearchRegion } from '../../models/Hotels/SearchRegion';
import { Residency } from '../../models/Hotels/Residency';

export interface HotelsSearchState {
    selectedHotel: SearchHotel | null;
    selectedRegion: SearchRegion | null;

    hotels: Map<string, SearchHotel>;
    regions: Map<number, SearchRegion>;
    loading: boolean;
    error: string;

    searchQuery: string;

    residencies: Array<Residency>;
    residencyQuery: string;
    residency: Residency | null;
    searchResidencies: Array<Residency>;
}

const initialState: HotelsSearchState = {
    hotels: Map<string, SearchHotel>(),
    regions: Map<number, SearchRegion>(),
    
    selectedHotel: null,
    selectedRegion: null,
    loading: false,
    error: '',

    searchQuery: '',
    residencies: Array<Residency>(),
    searchResidencies: Array<Residency>(),
    residencyQuery: '',
    residency: null
};

export function hotelsSearchState(state: HotelsSearchState = initialState, action: Action) {
    switch (action.type) {
        case SET_HOTEL: {
            const selectedHotel = (action as any).hotel;
            return {
                ...state,
                selectedHotel,
                selectedRegion: initialState.selectedRegion
            };
        }
        case SET_REGION: {
            const selectedRegion = (action as any).region;
            return {
                ...state,
                selectedRegion,
                selectedHotel: initialState.selectedHotel
            };
        }
        case RESET_SEARCH: {
            return {
                ...state,
                hotels: initialState.hotels,
                regions: initialState.regions,
                loading: initialState.loading
            };
        }
        case SEARCH_REQUEST: {
            return {
                ...state,
                hotels: initialState.hotels,
                regions: initialState.regions,
                loading: true,
                error: ''
            };
        }
        case SEARCH_RESPONSE: {
            const response = (action as any).response;
            const hotels = (response.result.hotels as Array<SearchHotel>)
                .map((h: SearchHotel) => new SearchHotel(h))
                .reduce((prev, cur) => prev.set(cur.id, cur), initialState.hotels);
            const regions = (response.result.regions as Array<SearchRegion>)
                .map((r: SearchRegion) => new SearchRegion(r))
                .reduce((prev, cur) => prev.set(cur.id, cur), initialState.regions);
            return {
                ...state,
                hotels,
                regions,
                loading: false
            };
        }
        case SEARCH_ERROR: {
            const error = (action as any).error;
            return {
                ...state,
                hotels: initialState.hotels,
                regions: initialState.regions,
                error,
                loading: false
            };
        }
        case SEARCH_QUERY: {
            const searchQuery = (action as any).query;
            return {
                ...state,
                searchQuery
            };
        }
        case SEARCH_RESIDENCIES_RESPONSE: {
            const residencies = (action as any).response.result;
            return {
                ...state,
                residencies,
                searchResidencies: residencies
            };
        }
        case SEARCH_RESIDENCY_QUERY: {
            const residencyQuery = (action as any).query;
            if (residencyQuery.length > 0) {
                const searchResidencies = state.residencies.filter(residency => {
                    return residency.name.toLowerCase().includes(residencyQuery.toLowerCase());
                });
                return {
                    ...state,
                    residencyQuery,
                    searchResidencies
                };
            } else {
                return {
                    ...state,
                    residencyQuery,
                    searchResidencies: state.residencies
                };
            }
        }
        case RESET_RESIDENCY_SEARCH: {
            return {
                ...state,
                searchResidencies: state.residencies
            };
        }
        case SET_RESIDENCY: {
            const residency = (action as any).residency;
            return {
                ...state,
                residency,
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Hotels/search.ts